module.exports = __webpack_public_path__ + "img/14.e300e644.jpg";